import type { ReactNode } from "react";
import { ExternalLink } from "lucide-react";
import { buildDocumentUrl, isApiUrl, openDocument } from "../../utils/document-url.utils";

export function ChatMessageAnchor({ href, children }: { href?: string; children: ReactNode }) {
  const transformedUrl = buildDocumentUrl(href) || href;
  const requiresAuth = transformedUrl && isApiUrl(transformedUrl);

  const handleClick = (e: React.MouseEvent) => {
    if (requiresAuth && transformedUrl) {
      e.preventDefault();
      openDocument(transformedUrl);
    }
  };

  return (
    <a
      href={transformedUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={"chat-message-anchor relative inline-flex items-baseline gap-0.5 text-xs"}
    >
      {children}
      <ExternalLink className="right-[0.5em] w-[0.75em] h-[0.75em]" />
    </a>
  );
}
